var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDiscord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#6e7191;}.c{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1158.529 4531.529)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1110 -4367)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(1110 4367)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-46.529 -162.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1159.005 4533.677)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.847,5.949H29.311V24.131H4.847Z",
    transform: "translate(-1.555 -1.675)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.268,33.963l-20.6-2.645c-2.226-.286-2.11-7.282-1.915-9.518l.992-11.322c.2-2.236,2.833-4.58,5.055-4.89L26.565,3.109c2.223-.31,6.752,8.1,6.708,10.344l-.331,16.956M18.177,9.891a15.424,15.424,0,0,0-7.412,1.869,14.264,14.264,0,0,1,4.6-2.357l-.276-.276a10.222,10.222,0,0,0-5.234,1.95A25.637,25.637,0,0,0,7.238,21.951a7.092,7.092,0,0,0,5.656,2.731l1.154-1.463a6.181,6.181,0,0,1-3.316-2.243,14.358,14.358,0,0,0,14.888,0,6.181,6.181,0,0,1-3.316,2.243l1.154,1.463a7.092,7.092,0,0,0,5.656-2.731A25.637,25.637,0,0,0,26.5,11.078a10.222,10.222,0,0,0-5.234-1.95l-.276.276a14.264,14.264,0,0,1,4.6,2.357,15.424,15.424,0,0,0-7.412-1.869m-3.364,6.16a1.975,1.975,0,0,1,1.9,2.064,2,2,0,0,1-1.9,2.064,1.993,1.993,0,0,1-1.885-2.064,1.972,1.972,0,0,1,1.885-2.064m6.778,0A2.073,2.073,0,1,1,19.7,18.116,1.985,1.985,0,0,1,21.59,16.051Z",
    transform: "translate(-2.653 -3.1)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscord);
export default __webpack_public_path__ + "static/media/icon_discord.d8b3fc0e18ec360ad878b74c8f3f06ca.svg";
export { ForwardRef as ReactComponent };